export default __webpack_public_path__ + "static/texture-top-5ff18d3ee113233b5a3b2f2cdd44f8c4.jpeg";